import React from 'react';

import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import NoFavorites from '../NoFavorites';
import CompanyGridCard from '../../Companies/CompaniesList/AllCompanies/CompanyGridCard';

import classes from './styles.module.scss';

export default function Companies({ companies, refetch, handleClose }) {
  const navigate = useNavigate();
  return (
    <div
      className={classNames(classes.Companies, {
        [classes.noFavorites]: companies?.length === 0,
      })}
    >
      {companies?.length === 0 ? (
        <NoFavorites companies />
      ) : (
        <div className={classNames(classes.companies)}>
          {companies?.map((company) => {
            return (
              <CompanyGridCard
                key={company?.id}
                toggleCandidateSelection={() => {}}
                selectedRows={[]}
                showCompanyInfo={() => {
                  navigate(`/tools/companies/company-details/${company?.id}`);
                  handleClose();
                }}
                company={company}
                refetch={refetch}
                isFavorite
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
